// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"20":"admin/css/app","187":"front/css/tailwind"}[chunkId] + ".css";
};